/**
 * Predefined recipe labels
 */
export const PREDEFINED_LABELS = [
  "Breakfast",
  "Lunch",
  "Dinner",
  "Dessert",
  "Appetizer",
  "Side Dish",
  "Snack",
  "Beverage",
  "Soup",
  "Salad",
  "Main Course",
  "Baking",
  "Grilling",
  "Vegetarian",
  "Vegan",
  "Gluten-Free",
  "Quick & Easy",
  "Meal Prep",
] as const;

export type PredefinedLabel = (typeof PREDEFINED_LABELS)[number];

// Legacy aliases
export const PREDEFINED_CATEGORIES = PREDEFINED_LABELS;
export type PredefinedCategory = PredefinedLabel;

/**
 * Get all available labels (predefined + box-specific custom labels)
 */
export function getAllLabels(customLabels: string[] = []): string[] {
  return [...PREDEFINED_LABELS, ...customLabels];
}

// Legacy alias
export const getAllCategories = getAllLabels;

/**
 * Check if a label is predefined
 */
export function isPredefinedLabel(label: string): boolean {
  return PREDEFINED_LABELS.includes(label as PredefinedLabel);
}

// Legacy alias
export const isPredefinedCategory = isPredefinedLabel;

/**
 * Get label display name with icon/emoji
 */
export function getLabelDisplayName(label: string): string {
  const emojiMap: Record<string, string> = {
    Breakfast: "🍳",
    Lunch: "🥗",
    Dinner: "🍽️",
    Dessert: "🍰",
    Appetizer: "🥖",
    "Side Dish": "🥔",
    Snack: "🍿",
    Beverage: "🥤",
    Soup: "🍲",
    Salad: "🥙",
    "Main Course": "🍖",
    Baking: "🧁",
    Grilling: "🔥",
    Vegetarian: "🥬",
    Vegan: "🌱",
    "Gluten-Free": "🌾",
    "Quick & Easy": "⚡",
    "Meal Prep": "📦",
  };

  const emoji = emojiMap[label] || "🏷️";
  return `${emoji} ${label}`;
}

// Legacy alias
export const getCategoryDisplayName = getLabelDisplayName;
